import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import StoreIdentifier from './App';
import { ErrorPage } from './components/ErrorPage';
import { queryParser } from './utils';

const validBrandId = ['cb', 'yb', 'vm'];
const parsedParams = queryParser();

(async () => {
  try {
    const resp = await fetch('/config.json');
    const runtimeConfig = await resp.json();
    if (!validBrandId.includes(parsedParams.brandParam)) {
      throw new Error('Invalid URL');
    }
    ReactDOM.render(
      <WebUIThemeProvider brandID="VM">
        <StoreIdentifier parsedParams={parsedParams} config={runtimeConfig} />
      </WebUIThemeProvider>,
      document.getElementById('root')
    );
  } catch (err) {
    err.message = `PROBLEM FETCHING RUNTIME CONFIG: ${err.message}`;
    ReactDOM.render(
      <WebUIThemeProvider brandID="VM">
        <ErrorPage error={err.message} />
      </WebUIThemeProvider>,
      document.getElementById('root')
    );
  }
})();
